module.exports = __webpack_public_path__ + "img/easy_bg04.ccb35bde.png";